import './styles/general.scss';
import "bootstrap";
import {initSplides} from "./scripts/splide";
import {initLightbox} from "./scripts/lightbox";
import {initCalculators} from "./scripts/calculator";

initSplides()
initLightbox()
initCalculators()
window.onload = () => {
}

window.onscroll = () => {

}

window.onresize = () => {
}
